import React, { useEffect, useState } from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import  { WebPubSubClient } from '@azure/web-pubsub-client';
import { Alert, Center, Loader } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';
import VehicleListV2 from './VehicleListV2';
import apiClient from './services/apiClient.js';
import SingleVehicleModalV2 from './SingleVehicleModalV2.jsx'

const Dashboard = () => {
  const { user, isAuthenticated, getAccessTokenSilently } = useAuth0();
  const [client, setClient] = useState(null);
  const [isLoadingPubsubClient, _setIsLoadingPubsubClient] = useState(false);
  const [pubSubError, setPubSubError] = useState('');
  const isLoadingPubsubClientRef = React.useRef(isLoadingPubsubClient);

  const setIsLoadingPubsubClient = data => {
    isLoadingPubsubClientRef.current = data;
    _setIsLoadingPubsubClient(data);
  };

  //need to get the groupname from login 
  const intialiseWebPubSubClient = async () => {
     if (!isAuthenticated || user['/roles'].length === 0) return;

    try {
      setPubSubError('');
      const accessToken = await getAccessTokenSilently({
          authorizationParams: {
                audience: process.env.REACT_APP_AUTH0_API_AUDIENCE,
            }
        });
      const userRole = user['/roles'][0];
        const params = {
           user: user.email,
           groupName: userRole
         }

        const result = await apiClient.getPubSubClientAccessUrlAsync(params, accessToken)
        const rawConnectionUrl = result?.connectionUrl;
        if (!rawConnectionUrl || typeof rawConnectionUrl !== 'string') {
          throw new Error('Missing Web PubSub connection URL.');
        }

        // Prevent mixed-content websocket failures on HTTPS localhost.
        const normalizedConnectionUrl = window.location.protocol === 'https:' && rawConnectionUrl.startsWith('ws://')
          ? `wss://${rawConnectionUrl.slice('ws://'.length)}`
          : rawConnectionUrl;

        const webClient = new WebPubSubClient({
            getClientAccessUrl: async () => {
              return normalizedConnectionUrl;
            }
          });
        await webClient.start();
        await webClient.joinGroup(userRole);

        setClient(webClient);
        console.log('pubsub client loading done!');
    } catch (error) {
      console.error('Failed to initialise Web PubSub client:', error);
      setPubSubError('Unable to connect to live vehicle monitoring right now. Please refresh or try again shortly.');
      setClient(null);
    } finally {
      setIsLoadingPubsubClient(false);
    }
  }

    useEffect(() => {
        if(isAuthenticated)
        {
          setIsLoadingPubsubClient(true);
          intialiseWebPubSubClient().catch((error) => {
            console.error('Unexpected dashboard initialisation error:', error);
            setPubSubError('Unable to connect to live vehicle monitoring right now. Please refresh or try again shortly.');
            setClient(null);
            setIsLoadingPubsubClient(false);
          });
        }
      
    }, [isAuthenticated]);

    const loadingSpinner = isLoadingPubsubClient ? 
    (
      <Center py="xl">
        <Loader size="lg" color="indigo" />
      </Center>
    ): null;

     if (!isAuthenticated || user['/roles'].length === 0){
      return (<div className="dashboard-content">Unauthorised!</div>)
    }

    return (
        <div className="dashboard-content" style={{ paddingTop: 0 }}>
            {loadingSpinner}
            {pubSubError && (
              <Alert
                icon={<IconAlertCircle size={16} />}
                color="red"
                variant="light"
                mx="md"
                mb="md"
                title="Live feed unavailable"
              >
                {pubSubError}
              </Alert>
            )}
            <SingleVehicleModalV2 groupName='servo1'/>
            {client && (
                <div className="container-fluid px-4 pt-0 pb-4">
                    <VehicleListV2 client={client} groupName='servo1'/>
                </div>
            )}
        </div>
    )

    return null;
}

export default Dashboard;